import styled from 'styled-components';

export const StyledEditor = styled.div`
  position: fixed;
  z-index: 10;
  background-color: #fff;
  width: 100%;
`;

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 400px 1fr;
  height: 100%;
  overflow-x: hidden;
`;
